/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Replace_Video1Inputs */

const vi_guidevideo_replace_video1 = /** @type {(inputs: Guidevideo_Replace_Video1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi video`)
};

/**

* @param {Guidevideo_Replace_Video1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_replace_video1 = /** @type {((inputs?: Guidevideo_Replace_Video1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Replace_Video1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_replace_video1(inputs)
});
export { guidevideo_replace_video1 as "guideVideo_replace_video" }